import React from "react";
import DeviceForm from "../DeviceForm";
import "./DeviceModal.css";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const DeviceModal = ({
  isModalOpen,
  onClose,
  selectedDevice,
  isUpdate = false,
}) => {
  return (
    <ModalWrapper
      title={`${isUpdate ? "Update" : "Add"} Device Configuration`}
      Device
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DeviceForm
        handleClose={onClose}
        selectedDevice={selectedDevice}
        isUpdate={isUpdate}
      />
    </ModalWrapper>
  );
};

export default DeviceModal;
